import { Fragment, useEffect } from 'react';
import ContentLoader from 'react-content-loader';
import { useNavigate, useParams } from 'react-router-dom';
import Container from '../../../../core/components/atoms/Container';
import PageHeader from '../../../../core/components/molecules/Header';
import { Typography } from '../../../../core/components/molecules/Typography';
import IconCard from '../../../../core/components/organism/IconCard';
import { Colors, IModules } from '../../../../core/models/disciplines';
import { getDisciplineName } from '../../../../core/utils/new_discipline';
import { useModule } from '../../hooks/useModule';
import { disciplines } from '../../utils/disciplineHelper';
import { useFilterConfigStore } from '../../stores/filterConfig';
import { useNewSubjectStore } from '../../stores/newSubjectStore';

export default function ModulosPage() {
  const navigate = useNavigate();
  const { discipline } = useParams();

  const { resetFilters } = useFilterConfigStore();
  const { resetSubjects } = useNewSubjectStore();
  const { mutate, isPending, data } = useModule();

  useEffect(() => {
    if (discipline) {
      resetFilters();
      resetSubjects();
      mutate(discipline);
    }
  }, [discipline]);

  const handleSelect = (module: IModules) => {
    if(module) {
      navigate(`/disciplinas/${discipline}/modulo/${module.slug}/tipo/videoaula`)
    }
  }

  return (
    <Container direction='col' gap='xl'>
      <div className='flex flex-col justify-between md:flex-row md:items-end'>
        <PageHeader
          module='Disciplina'
          title={
            disciplines.find((it) => it.slug === discipline)?.label ||
            getDisciplineName(discipline ?? '') ||
            ''
          }
          isDropdown
          dropdownItems={disciplines}
        />
      </div>
      {isPending ? (
        <div className='grid xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-lg'>
          {Array.from({ length: 12 }, (_, i) => (
            <ContentLoader
              key={i}
              backgroundColor={'#a7adba'}
              foregroundColor={'#c0c5ce'}
              viewBox='0 0 300 350'
            >
              <rect x='0' y='2' rx='2' ry='2' width="100%" height='100%' />
            </ContentLoader>
          ))}
        </div>
      ) : (
        <Fragment>
          <Typography size='h6' type='titleSection'>
            MÓDULOS
          </Typography>
          <div className='grid gap-lg xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-4'>
            {data && data.length > 0 && data.map((it, i) => (
              <IconCard
                key={i}
                title={it.title}
                description={it.description}
                subjects={it.subject.length}
                slug={discipline || ''}
                color={discipline as Colors}
                type='modules'
                action={() => handleSelect(it)}
                isReleased={it.construction === true ? false : true}
              />
            ))}
          </div>
        </Fragment>
      )}
    </Container>
  );
}
